<div class="app flex-row align-items-center">
    <div class="container d-flex justify-content-center">
        <div class="">
            <div class="col-12">
                <div class="error-img">
                    <img src="/assets/images/icons/time.png">
                </div>
                <div  class="col-10">
                    <div class="d-block row">
                        {{'dam' | translate | async }}
                    </div>
                   
                   <div class="d-block row lead"> 
                       Device ID: <strong style="font-weight: bold;">{{config.deviceID}} </strong>
                    </div>
                    <div class="d-block row"> 
                        <button type="button" class="btn btn-form-mobile btn-sm btn-danger form-button"
                        (click)="logout()">Logout</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>